import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { VoucherRedemption } from '../types/voucher-redemption.type';

export type GetListVoucherRedemptionParams = Partial<ApiParamsDefault> & {
  voucher_id: string;
};
export type GetListVoucherRedemptionResponse =
  ApiResponsePagination<VoucherRedemption>;

export const getListVoucherRedemption = async (
  params: GetListVoucherRedemptionParams
): Promise<GetListVoucherRedemptionResponse> => {
  const { voucher_id, ...query } = params;
  const url = `voucher/${voucher_id}/redemption`;

  return await apiClient.get(url, { params: query });
};

export const GET_LIST_VOUCHER_REDEMPTION_QUERY_KEY = 'list-voucher-redemption';
export function getListVoucherRedemptionQueryOptions(
  params: GetListVoucherRedemptionParams
) {
  return queryOptions({
    queryKey: [GET_LIST_VOUCHER_REDEMPTION_QUERY_KEY, params],
    queryFn: () => getListVoucherRedemption(params),
  });
}
